export default __webpack_public_path__ + "./images/noPhoto68.c53b0ba3.svg";